export default function NumberFormatter(num: number) {
  const bengaliNumberFormatter = new Intl.NumberFormat('bn');

  return bengaliNumberFormatter.format(num);
}
